import { applyDecompositionTreeMetricFilter } from '@process-advisor/process-miner/api/methods/decompositionTree/applyDecompositionTreeMetricFilter';
import { applyAttributeFilter } from '@process-advisor/process-miner/api/methods/decompositionTree/applyAttributeFilter';
import { applyDecompositionTreeValueFilter } from '@process-advisor/process-miner/api/methods/decompositionTree/applyDecompositionTreeValueFilter';
import { setDiagramDecompositionTree } from '@process-advisor/process-miner/api/methods/decompositionTree/setDiagramDecompositionTree'
import { setDecompositionTreeMinMaxTasks } from '@process-advisor/process-miner/api/methods/decompositionTree/setMinMaxTasks'
import { getDecompositionTreeMinMaxTasks } from '@process-advisor/process-miner/api/methods/decompositionTree/setMinMaxTasks'
import { setDecompositionTreeMinMaxMetric } from '@process-advisor/process-miner/api/methods/decompositionTree/setMinMaxMetric'
import { getDecompositionTreeMinMaxMetric } from '@process-advisor/process-miner/api/methods/decompositionTree/setMinMaxMetric'

export const decompositionTreeMethods = {
    applyDecompositionTreeMetricFilter,
    applyAttributeFilter,
    applyDecompositionTreeValueFilter,
    setDiagramDecompositionTree,
    setDecompositionTreeMinMaxMetric,
    getDecompositionTreeMinMaxMetric,
    setDecompositionTreeMinMaxTasks,
    getDecompositionTreeMinMaxTasks,
};
